// extracted by mini-css-extract-plugin
export var productImage = "_pf-1";
export var viewLink = "_pf-2";
export var wishlistItem = "_pf-0";